import { SeeqNames } from '@/main/app.constants.seeqnames';
import { VantageNames } from '@/vantage/constants';

/** Grouping for table data */
export interface GroupBy {
  /** Columns to group by */
  rowGroupColumnIds: string[];
  /** Columns to aggregate on */
  valueColumns: { columnId: string; aggregationFunction?: string }[];
  /** Expanded group nodes */
  groupKeys: string[];
}

export const VANTAGE_COLUMN_KEY_TO_TABLE_COLUMN_MAP = {
  [`${VantageNames.Columns.Condition}*`]: VantageNames.Columns.Condition,
  [VantageNames.Columns.ConditionID]: SeeqNames.MaterializedTables.ItemIdColumn,
  [VantageNames.Columns.TimeCreated]: SeeqNames.MaterializedTables.CreatedAtColumn,
  [VantageNames.Columns.TimeUpdated]: SeeqNames.Properties.UpdatedAt,
};

export const VANTAGE_GROUPING_COLUMN_KEY_TO_TABLE_COLUMN_MAP = {
  [`${VantageNames.Columns.Condition}*`]: SeeqNames.MaterializedTables.ItemIdColumn,
};

/**
 * The maximum number of distinct values to fetch for a column when populating filter options.
 * A conservative limit is set to avoid performance issues with large datasets.
 */
export const SET_OPTIONS_FETCH_LIMIT = 100;
